document.addEventListener('DOMContentLoaded', () => {
  // ====== CONFIG  ======
  const SELECTORS = {
    container: '[data-product]',
    productJson: 'script[data-product-json]',
    optionPositionAttr: 'data-option-position',
    optionInputs: '[name^="options"], [data-popout-option]',
    optionInputsCurrent: '[name^="options"]:checked, [name^="options"][type="hidden"]',
    popout: '[data-popout]',

    formWrapper: '[data-form-wrapper]',
    originalSelect: '[data-product-select]',
    inputId: 'input[name="id"]',

    addToCart: '[data-add-to-cart], .add-to-cart-product',
    addToCartText: '[data-add-to-cart-text], .btn__text',
  };

  const CLASSES = {
    soldOut: 'sold-out',
    unavailable: 'unavailable',
    sale: 'sale',
  };

  // ====== HELPERS ======
  function parseProductJSON(container) {
    const script = container.querySelector(SELECTORS.productJson) || document.querySelector(SELECTORS.productJson);
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      console.error('Failed to parse data-product-json', e);
      return null;
    }
  }

  function getOptionPositionIndex(el) {
    const parent = el.closest(`[${SELECTORS.optionPositionAttr}]`);
    if (!parent) return null;
    const pos = parseInt(parent.getAttribute(SELECTORS.optionPositionAttr), 10);
    if (Number.isNaN(pos)) return null;
    return pos - 1; // liquid positions start at 1
  }

  function getOptionValue(el) {
    return el.value || el.getAttribute('data-value') || el.getAttribute('data-popout-option');
  }

  function getCurrentSelections(container, productJSON) {
    const selections = new Array((productJSON?.options || []).length).fill(null);

    const current = container.querySelectorAll(SELECTORS.optionInputsCurrent);
    current.forEach((el) => {
      const idx = getOptionPositionIndex(el);
      const val = getOptionValue(el);
      if (idx === null || !val) return;
      selections[idx] = val;
    });

    return selections;
  }

  function findVariant(productJSON, selections) {
    const variants = productJSON?.variants || [];
    return variants.find((v) => {
      for (let i = 0; i < selections.length; i++) {
        if (selections[i] == null) continue;
        if (v.options[i] !== selections[i]) return false;
      }
      return true;
    });
  }

  function syncAddToCartButtons(variantId) {
    if (!variantId) return;

    const buttons = document.querySelectorAll('button[data-add-to-cart]');

    buttons.forEach((btn) => {
        btn.setAttribute('product-id', String(variantId));

        btn.setAttribute('data-variant-id', String(variantId));

        btn.setAttribute('data-product-id', String(variantId));
    });
  }

  function updateVariantIdEverywhere(container, variant) {
    const formWrappers = container.querySelectorAll(SELECTORS.formWrapper);
    const inputIds = container.querySelectorAll(SELECTORS.inputId);
    const selects = container.querySelectorAll(SELECTORS.originalSelect);

    // hidden input[name=id]
    inputIds.forEach((inp) => {
      inp.value = variant ? String(variant.id) : '';
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // select[data-product-select]
    selects.forEach((sel) => {
      if (!variant) return;
      sel.value = String(variant.id);
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // history ?variant=
    if (variant?.id) {
      syncAddToCartButtons(variant.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState({ path: url.toString() }, '', url.toString());
    }

    container.dispatchEvent(
      new CustomEvent('theme:variant:change', {
        bubbles: true,
        detail: { variant },
      })
    );
  }

  function updateAddToCartUI(container, variant) {
    const buttons = container.querySelectorAll(SELECTORS.addToCart);
    const texts = container.querySelectorAll(SELECTORS.addToCartText);

    buttons.forEach((btn) => {
      btn.classList.remove('notify-me', 'add-to-cart-product--notify', 'notify');
      btn.removeAttribute('data-variant-id');
      btn.removeAttribute('id');

      if (!variant) {
        btn.disabled = true;
        return;
      }

      btn.disabled = false;

      if (!variant.available) {
        btn.id = 'BIS_trigger';
        btn.setAttribute('data-variant-id', String(variant.id));
        btn.classList.add('notify-me');
      }
    });

    texts.forEach((el) => {
      if (!variant) {
        el.textContent = window.theme?.strings?.unavailable || 'Unavailable';
      } else if (!variant.available) {
        el.textContent = window.theme?.strings?.notifyMe || 'Notify Me';
      } else {
        el.textContent = window.theme?.strings?.addToCart || 'Add to Cart';
      }
    });
  }

  function updateOptionStates(container, productJSON, currentSelections) {
    const optionEls = container.querySelectorAll(SELECTORS.optionInputs);

    optionEls.forEach((el) => {
      const idx = getOptionPositionIndex(el);
      const val = getOptionValue(el);
      if (idx === null || !val) return;

      const popout = el.closest(SELECTORS.popout);

      const hypothetical = currentSelections.slice();
      hypothetical[idx] = val;

      const found = findVariant(productJSON, hypothetical);

      // reset classes
      el.classList.remove(CLASSES.soldOut, CLASSES.unavailable);
      if (el.parentNode) el.parentNode.classList.remove(CLASSES.sale);

      if (popout) popout.classList.remove(CLASSES.soldOut, CLASSES.unavailable, CLASSES.sale);

      // apply classes
      if (!found) {
        if (popout) popout.classList.add(CLASSES.unavailable);
        el.classList.add(CLASSES.unavailable);
      } else if (found.available === false) {
        if (popout) popout.classList.add(CLASSES.soldOut);
        el.classList.add(CLASSES.soldOut);
      }

      if (found && found.compare_at_price > found.price && window.theme?.settings?.variantOnSale) {
        if (el.parentNode) el.parentNode.classList.add(CLASSES.sale);
      }
    });
  }

  // ====== INIT ======
  const container = document.querySelector(SELECTORS.container) || document;
  const productJSON = parseProductJSON(container);
  if (!productJSON?.variants?.length) return;

  function refreshAll() {
    const selections = getCurrentSelections(container, productJSON);
    console.log('productJSON: ', productJSON);
    console.log('Current selections:', selections);
    const variant = findVariant(productJSON, selections);
    console.log('variant: ', variant);
    updateVariantIdEverywhere(container, variant);
    updateAddToCartUI(container, variant);
    updateOptionStates(container, productJSON, selections);
  }

  // initial
  refreshAll();

  // change listeners (radio/select/popout)
  container.addEventListener('change', (e) => {
    console.log('change detected', e.target);
    const target = e.target;
    if (!target) return;

    if (!target.matches(SELECTORS.optionInputs)) return;

    refreshAll();
  });
});